import React from "react";
import "./style.scss";
import "../../../../style/block.scss";
import "../../../../style/variables.scss";
import "../../../../style/buttons.scss";
import BasketTable from "../BasketTable";
import BasketSummary from "../BasketSummary";
import BasketCodePromotion from "../BasketCodePromotion";
import { useSelector } from "react-redux";
import { State } from "../../../store";
import { BasketItem } from "../../../models/BasketItem";
import { PaymentLogos } from "../../../../features/PaymentLogo";
import useParentMessage from "../../../../utils/hooks/useParentMessage";
import { useTranslation } from "react-i18next";
import { MdOutlineKeyboardArrowLeft } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import EAButton from "../../shared/Buttons/EAButton";
import QbIntegration from "../QbIntegration";
import EAPageMessage from "../../shared/EAPageMessage";
import EAAlert from "../../shared/EAAlert";

interface IProps {
  setStep: (index: number) => void;
  handleDelete: (index: number) => void;
  handlePromotion: (promotionCode: string) => void;
  promoMessage: string;
  basket: BasketItem[];
  total: number;
  primaryPrice: number;
  handleGetBasket: Function;
  hasSurvey: boolean;
  hideExerciseInfo?: boolean;
}

const BasketFirstStep: React.FC<IProps> = ({
  setStep,
  basket,
  total,
  primaryPrice,
  handleDelete,
  handleGetBasket,
  handlePromotion,
  promoMessage,
  hasSurvey,
  hideExerciseInfo,
}: IProps) => {
  const { t } = useTranslation();
  const isLogging = useSelector((state: State) => state.auth.isLoggedIn);
  const { scrollToTop } = useParentMessage();
  const navigate = useNavigate();
  const homePage = sessionStorage.getItem("HomePage");
  const saleConfiguration = useSelector((state: State) => state.config.configuration);

  const whichStep = () => {
    if (hasSurvey) {
      setStep(2);
    } else if (isLogging) {
      setStep(5);
    } else {
      setStep(3);
    }
  };

  return (
    <React.Fragment>
      <div className="basket-first-step flex-between">
        <div className="basket shadow">
          <div className="basket-list">
            {basket.length > 0 ? (
              <BasketTable handleDelete={handleDelete} handleGetBasket={handleGetBasket} basket={basket} hideExerciseInfo={hideExerciseInfo} />
            ) : (
              <div className="alert alert-yellow">
                <b>{t("koszyk_jest_pusty")}</b>
              </div>
            )}
            <EAPageMessage
              message={saleConfiguration.message_summary}
            />
            {hasSurvey && (
              <EAAlert
                type="warning"
                message={t("koszyk_wymaga_dodatkowych_informacji")}
              />
            )}
          </div>
        </div>
        <div className="summary">
          <div className="basket-box border shadow ">
            <BasketSummary total={total} primaryPrice={primaryPrice} />
            <EAButton
              title={hasSurvey ? t("uzupelnij_dodatkowe_informacje") : t("przejdz_do_platnosci")}
              onClick={() => {
                whichStep();
                scrollToTop();
              }}
              fullWidth
              disabled={basket.length === 0}
            />

            {homePage && (
              <EAButton
                title={t("dodaj_kolejne_bilety")}
                onClick={() => navigate(homePage)}
                startIcon={<MdOutlineKeyboardArrowLeft />}
                variant="text"
                fullWidth
              />
            )}

            <PaymentLogos />
          </div>
          <QbIntegration onRefreshBasket={handleGetBasket} />
          <div className="basket-box border shadow">
            <BasketCodePromotion handlePromotion={handlePromotion} promoMessage={promoMessage} />
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default BasketFirstStep;
